export const ZOOM_PRESETS = [50, 75, 100, 125, 150, 200] as const;

export const ZOOM_OPTIONS = ZOOM_PRESETS.map((value) => ({ value, label: `${value}%` }));

export const DEFAULT_ZOOM_PERCENT = 100;

export const MIN_ZOOM_PERCENT = 25;
export const MAX_ZOOM_PERCENT = 400;

const SORTED_PRESETS = [...ZOOM_PRESETS].sort((a, b) => a - b);
const MIN_ZOOM = SORTED_PRESETS[0];
const MAX_ZOOM = SORTED_PRESETS[SORTED_PRESETS.length - 1];

export const nextZoomPreset = (current: number): number =>
  SORTED_PRESETS.find((v) => v > current) ?? MAX_ZOOM;

export const previousZoomPreset = (current: number): number => {
  const lower = SORTED_PRESETS.filter((v) => v < current);
  return lower.length > 0 ? lower[lower.length - 1] : MIN_ZOOM;
};
